import React, { useRef, useState } from 'react';
import SignatureCanvas from 'react-signature-canvas';
import { storage, ref, uploadBytes, getDownloadURL } from '../../firebase';

const SignatureField = ({ setValue, fieldName, setSignatureURL, setSignatureImage, isSignatureValid, setIsSignatureValid }) => {
    const [imageURL, setImageURL] = useState(null);
    const sigCanvas = useRef();

    const clearSignature = () => {
        sigCanvas.current.clear();
        setImageURL(null);
    };

    const saveSignature = async () => {
        if (sigCanvas.current.isEmpty()) {
            alert('Veuillez signer avant de soumettre.');
            return;
        }

        const signatureImage = sigCanvas.current.getTrimmedCanvas().toDataURL('image/png');

        setSignatureImage(signatureImage)

        const imageRef = ref(storage, `signatures/${Date.now()}.png`);
        const response = await fetch(signatureImage);
        const blob = await response.blob();

        try {
            const snapshot = await uploadBytes(imageRef, blob);
            const downloadURL = await getDownloadURL(snapshot.ref);
            setImageURL(downloadURL);
            setValue(fieldName, downloadURL);
            setSignatureURL(downloadURL)
            setIsSignatureValid(true)
        } catch (error) {
            console.error('Erreur lors de l\'upload de la signature', error);
        }
    };

    return (
        <div className="signature-field">
            <SignatureCanvas
                ref={sigCanvas}
                penColor="black"
                backgroundColor="white"
                canvasProps={{ width: 320, height: 200, className: 'border rounded-xl border-2 border-[#000]' }}
            />
            <div className="actions mt-4">
                <button type="button" onClick={saveSignature} className={`${imageURL ? "bg-green-800" : "bg-purple-800"} text-white py-2 px-4 rounded mr-2`}>
                    {imageURL ? "Confirmé !" : "Confirmer la signature"}
                </button>
                <button type="button" onClick={clearSignature} className="bg-gray-500 text-white py-2 px-4 rounded">
                    Effacer
                </button>
            </div>
            {!imageURL && isSignatureValid === false && (
                <p className='text-red-700'>La signature est obligatoire ! N'oubliez pas de confirmer celle-ci.</p>
            )}
            {imageURL && (
                <div className="signature-preview mt-4">
                    <h4>Signature enregistrée :</h4>
                    <img src={imageURL} alt="Signature" width={200} />
                </div>
            )}
        </div>
    );
};

export default SignatureField;
